var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xl":"","white":""}},[_c('iframe',{staticClass:"iframe-az-cronos pa-3",attrs:{"title":"AZCronos","src":_vm.getCronosCategoriaEscolhidaUrl,"id":"iframAZCronos"}})])}
var staticRenderFns = []

export { render, staticRenderFns }